import classNames from "classnames";
import { FunctionComponent, useState } from "react";
import Button from "rivals/components/shared/Button";
import CustomButton from "rivals/components/shared/CustomButton";
import Link from "rivals/components/shared/Link";
import { PATHS } from "rivals/shared/constants";
import styles from "./FAQSection.module.scss";
import strings from "./strings";
import { ComProps, FAQProps } from "./types";

const FAQ: FunctionComponent<FAQProps> = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleCaretClass = classNames(styles.toggleCaret, {
    [styles.open]: isOpen,
    [styles.closed]: !isOpen
  });

  const answerSection = <div className={styles.answer}>{answer}</div>;

  return (
    <div className={styles.questionSection}>
      <CustomButton
        ariaLabel="FAQ"
        className={styles.clickable}
        onClick={(): void => {
          setIsOpen(!isOpen);
        }}
      >
        <div className={styles.buttonContentWrapper}>
          <div className={styles.question}>{question}</div>
          <div className={toggleCaretClass}></div>
        </div>
      </CustomButton>
      {isOpen ? answerSection : null}
    </div>
  );
};

const FAQSection: FunctionComponent<ComProps> = ({ selectedSiteName }) => {
  if (!selectedSiteName) {
    return null;
  }

  const {
    sectionTitle,
    questionOne,
    answerOne,
    questionTwo,
    answerTwo,
    questionThree,
    answerThree,
    questionFour,
    answerFourSegment,
    answerFourAction,
    moreFAQs
  } = strings;

  const allFAQs = [
    {
      answer: answerOne(selectedSiteName),
      question: questionOne(selectedSiteName)
    },
    {
      answer: answerTwo,
      question: questionTwo
    },
    {
      answer: answerThree(selectedSiteName),
      question: questionThree
    },
    {
      answer: (
        <div>
          <span>{answerFourSegment}</span>
          <Link href={PATHS.CONTACT}>{answerFourAction}</Link>
        </div>
      ),
      question: questionFour
    }
  ];

  return (
    <div className={styles.faqSection}>
      {sectionTitle}
      <div className={styles.questionsContainer}>
        {allFAQs.map((QandA, index) => (
          <FAQ answer={QandA.answer} key={index} question={QandA.question} />
        ))}
        <div className={styles.buttonSection}>
          <Button buttonText={moreFAQs} inverted url={PATHS.MEMBER_SERVICES} />
        </div>
      </div>
    </div>
  );
};

export default FAQSection;
